import { useEffect, useState } from "react";

const NAV_LINKS = [
  { href: "#live", label: "正在热播" },
  { href: "#features", label: "玩法亮点" },
  { href: "#rank", label: "吃瓜热榜" },
  { href: "#hosts", label: "人气主播" },
  { href: "#reviews", label: "用户口碑" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex w-full items-center justify-between px-4 md:px-8 h-[76px]">
        <a href="#top" className="flex items-center gap-2.5" aria-label="吃瓜快手首页">
          <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-gradient-to-br from-primary-500 to-accent-500 text-xl font-bold text-background-50">
            瓜
          </span>
          <span className="flex flex-col leading-none">
            <span className={`font-bold text-lg ${solid ? "text-foreground-950" : "text-background-50"}`}>
              吃瓜快手
            </span>
            <span className={`font-accent-latin text-[11px] ${solid ? "text-primary-600" : "text-background-100/90"}`}>
              Chigua Live
            </span>
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-1">
          {NAV_LINKS.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className={`rounded-full px-4 py-2 text-sm font-medium transition-colors whitespace-nowrap ${
                  solid ? "text-foreground-700 hover:bg-secondary-100 hover:text-foreground-950" : "text-background-100 hover:text-background-50 hover:bg-background-50/15"
                }`}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#live"
            className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition hover:bg-primary-600 whitespace-nowrap"
          >
            <i className="ri-live-line text-base" />
            进入吃瓜现场
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className={`flex lg:hidden h-11 w-11 items-center justify-center rounded-full transition ${
              solid ? "text-foreground-950 bg-secondary-100" : "text-background-50 bg-background-50/15"
            }`}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-xl`} />
          </button>
        </div>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 pt-2 pb-4">
          <ul className="flex flex-col gap-1">
            {NAV_LINKS.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-xl px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-secondary-100 hover:text-foreground-950"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#live"
            onClick={() => setOpen(false)}
            className="mt-2 flex items-center justify-center gap-1.5 rounded-full bg-primary-500 px-5 py-3 text-sm font-semibold text-foreground-950"
          >
            <i className="ri-live-line text-base" />
            进入吃瓜现场
          </a>
        </div>
      )}
    </header>
  );
}